import type { FaireProductEntity } from "../../entity_types/product";

export const atc_fs_17: FaireProductEntity = {
  token: "atc_fs_17",
  type: "product",
  name: "Cherry Limeade Prebiotic Soda",
  brandName: "Poppi",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/44e7069cdea416cad77ea239b6deac6b143b727ffd09d957cc28ac4ab3b2c237.webp",
  priceDollars: 14,
  msrpDollars: 28,
  description: "ATC migration seed product",
  tags: ["beverage", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
